/** Two-letter monogram from a name or e-mail ("Moje firma s.r.o." → "MF", "jan.novak@…" → "JN"). */
export function initials(source: string): string {
  const words = source
    .replace(/@.*$/, "")
    .split(/[\s._-]+/)
    .filter((w) => /\p{L}/u.test(w));
  const letters = words.slice(0, 2).map((w) => w.match(/\p{L}/u)![0]);
  return (letters.join("") || "?").toUpperCase();
}
